/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockManageSummaryResVo } from './StockManageSummaryResVo';
import {
    StockManageSummaryResVoFromJSON,
    StockManageSummaryResVoFromJSONTyped,
    StockManageSummaryResVoToJSON,
    StockManageSummaryResVoToJSONTyped,
} from './StockManageSummaryResVo';

/**
 * 
 * @export
 * @interface ResponseStockManageSummaryResVo
 */
export interface ResponseStockManageSummaryResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseStockManageSummaryResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseStockManageSummaryResVo
     */
    message?: string;
    /**
     * 
     * @type {StockManageSummaryResVo}
     * @memberof ResponseStockManageSummaryResVo
     */
    data?: StockManageSummaryResVo;
}

/**
 * Check if a given object implements the ResponseStockManageSummaryResVo interface.
 */
export function instanceOfResponseStockManageSummaryResVo(value: object): value is ResponseStockManageSummaryResVo {
    return true;
}

export function ResponseStockManageSummaryResVoFromJSON(json: any): ResponseStockManageSummaryResVo {
    return ResponseStockManageSummaryResVoFromJSONTyped(json, false);
}

export function ResponseStockManageSummaryResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseStockManageSummaryResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : StockManageSummaryResVoFromJSON(json['data']),
    };
}

export function ResponseStockManageSummaryResVoToJSON(json: any): ResponseStockManageSummaryResVo {
    return ResponseStockManageSummaryResVoToJSONTyped(json, false);
}

export function ResponseStockManageSummaryResVoToJSONTyped(value?: ResponseStockManageSummaryResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': StockManageSummaryResVoToJSON(value['data']),
    };
}

